var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"copyright float-right"},[_vm._v("\n      © "+_vm._s(_vm.currentYear)+" por\n      "),_c('a',{attrs:{"href":"https://www.grupodiginet.com.br","target":"_blank"}},[_vm._v("Grupo Diginet")]),_vm._v(".\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }